import {Injectable} from '@angular/core';
import {AsaxElasticService, ElasticFiltersService} from 'asax-elastic';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AladinCellsService {
  constructor(private readonly asaxElasticService: AsaxElasticService,
              private readonly elasticFiltersService: ElasticFiltersService) {
  }

  searchCells(mocOrder: number, polygon: string, filters: any, filtersMappingSearchProperties: any): Observable<any> {
    const elasticDSLQueryBodyFromFilters = this.elasticFiltersService.buildElasticDSLQueryBodyFromFilters(filters, filtersMappingSearchProperties);
    const queryCells = buildQueryCells(filtersMappingSearchProperties.astrofilt, polygon, mocOrder);

    return this.asaxElasticService.searchByQuery({
      index: 'observations',
      body: {
        from: 0,
        size: 0,
        query: elasticDSLQueryBodyFromFilters,
        aggregations: queryCells
      }
    }).pipe(
      map(({aggregations}) => mapResponseToCells(aggregations, mocOrder)),
      catchError(() => of([]))
    );
  }
}

const buildQueryCells = (searchProperty: any, polygon: string, order: number): any => {
  if (searchProperty.isNested) {
    return {
      aggs: {
        nested: {path: searchProperty.path},
        aggs: {grid: {footprint_grid: {field: searchProperty.property, order, points: false, fov: polygon}}}
      }
    };
  } else {
    return {
      grid: {
        footprint_grid: {field: searchProperty.property, order, points: false, fov: polygon}
      }
    };
  }
};

const mapResponseToCells = (aggregations: any, mocOrder: number): any => {
  const {grid} = aggregations?.aggs || aggregations;

  return grid?.buckets?.map(bucket => ({key: +bucket.key, total: +bucket.doc_count, mocOrder})) || [];
};
